// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment__body[data-v-19e3dc6f]{margin-top:15px}.comment__body .btn[data-v-19e3dc6f]{display:block;margin-left:auto;width:intrinsic;width:-moz-max-content;width:-webkit-max-content}@media screen and (max-width:768px){.comment__body[data-v-19e3dc6f]{margin:15px 0}.comment__body .btn[data-v-19e3dc6f]{margin:0 auto}}", ""]);
// Exports
module.exports = exports;
